import Handlebars from "handlebars-template-loader/runtime";
import templateBookViewerTocItem from "templates/viewers/bookViewerTocItems.hbs";

Handlebars.registerHelper("bookViewerTocItems", function (tocData, margin) {
  margin = margin === undefined ? 0 : margin + 5;
  return templateBookViewerTocItem({ tocData, margin });
});
